"use client";

import Link from "next/link";
import { track } from "@/lib/analytics";
import Magnetic from "./Magnetic";

type Props = {
  primaryHref: string;
  primaryLabel: string;
  secondaryHref: string;
  secondaryLabel: string;
};

export default function HeroCta({
  primaryHref,
  primaryLabel,
  secondaryHref,
  secondaryLabel,
}: Props) {
  return (
    <div className="flex items-center gap-4 flex-wrap">
      <Magnetic strength={16}>
        <Link
          href={primaryHref}
          onClick={() => track("cta_click", { cta_text: primaryLabel, destination: primaryHref })}
          className="group inline-flex items-center gap-2 px-7 py-3 bg-[var(--accent)] text-[var(--on-accent)] font-mono text-xs uppercase tracking-widest rounded-full hover:opacity-90 transition-opacity"
        >
          {primaryLabel}
          <svg
            className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14m-6-6l6 6-6 6" />
          </svg>
        </Link>
      </Magnetic>
      <Magnetic strength={12}>
        <Link
          href={secondaryHref}
          onClick={() => track("cta_click", { cta_text: secondaryLabel, destination: secondaryHref })}
          className="inline-flex items-center px-7 py-3 border border-white/15 text-[var(--text)] font-mono text-xs uppercase tracking-widest rounded-full hover:border-[var(--accent)]/50 hover:text-[var(--accent-text)] transition-colors"
        >
          {secondaryLabel}
        </Link>
      </Magnetic>
    </div>
  );
}
